/* ------------------------------------------------------------------------
  Copyright (c) 2016, VoiceVibes, Inc

  VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
  All contents of this file are proprietary and confidential. No part of
  any of the contents of this file may be disclosed in any manner to
  a third party without the prior written consent of VoiceVibes, Inc.
  Unauthorized copying of this file, via any medium is strictly prohibited.
----------------------------------------------------------------------------- */

<template>
  <span class="navbar-basic">
    <nav
      id="mobile-navbar"
      :ref="navRef"
      :class="(isSmallViewport) ? 'mobile-navbar navbar navbar-default' : 'navbar navbar-default'"
    >
      <div class="container-fluid">
        <div
          class="navbar-header"
          style="float:left"
        >
          <a
            class="sr-only sr-only-focusable"
            style="color: white !important; font-size: 14pt;"
            href="#content"
          >
            Skip to main content
          </a>
          <a
            href="http://www.myvoicevibes.com"
            class="navbar-brand"
          >
            <img
              v-if="logoPath && logoPath !== 'btc' && logoPath !== 'vv'"
              alt="voicevibes logo"
              rel="homepage"
              :src="logoPath"
            >
            <svg
              v-else
              class="icon-btc"
              :style="logoPath === 'vv' ? 'height: 48px; width: 94px; padding: 0 5px;' : 'height: 40px; width: 140px;'"
            >
              <use :xlink:href="'/static/svg-symbols.svg#icon-' + logoPath" />
            </svg>
          </a>
        </div>
        <div
          v-if="!isFreeTrial && showSignIn"
          class="navbar-right text-right text-nowrap"
        >
          <span class="navbar-text hidden-sm hidden-xs">
            Already have an account?
          </span>
          <router-link
            class="btn btn-default navbar-btn"
            style="margin-right: 10px;"
            :to="signInLink"
          >
            Sign in
          </router-link>
        </div>
      </div>
    </nav>
    <div :class="(isSmallViewport) ? 'navbar-bumper' : 'hidden-nav'">
&nbsp;
    </div>
  </span>
</template>

<script>
import util from '../utils/util';

export default {
  data() {
    return {
      collapsed: true,
      currentMode: 'manager',
      navRef: 1,
    };
  },
  computed: {
    logoPath: {
      cache: false,
      get() {
        const logo = (this.$store.getters.org && this.$store.getters.org.whiteLabelLogo) ?
          this.$store.getters.org.whiteLabelLogo : null;

        // Logos rendered from main SVG file
        if (logo === 'btc') return 'btc';
        if (!logo) return 'vv';

        // White label logo URL
        return 'https://voicevibes.s3.amazonaws.com/static/images/' + logo;
      }
    },
    isSmallViewport: {
      cache: false,
      get: util.isSmallViewport
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    showSignIn() {
      return !this.isAuthenticated && !this.$route.meta.hideSignIn;
    },
    signInLink() {
      return this.$store.getters.signInLink;
    },
    isFreeTrial() {
      return !!(this.user && this.user.metadata && this.user.metadata.freeTrial);
    },
  },
  created() {
    let signIn = { name: 'sign-in' };
    if (this.$route.query && this.$route.query.code) {
      signIn.query = { code: this.$route.query.code };
    }
    this.$store.dispatch('switchSignInLink', signIn);
  },
};
</script>
